import { getStoreBuilder, BareActionContext } from 'vuex-typex'
import { RootState } from "@/types"
import { PropertiesState, PropertiesStore, Property } from "./types"
import firebase from 'firebase'

// const delay = (duration: number) => new Promise((c, e) => setTimeout(c, duration))

const b = getStoreBuilder<RootState>().module('properties', { items: [] })
const stateGetter = b.state()



export const propertiesStore: PropertiesStore = {
  // state
  get state() { return stateGetter() },

  // Load properties
  loadProperties: b.dispatch(loadProperties),
  loadProperty: b.dispatch(loadProperty)

}


async function loadProperties(
  context: BareActionContext<PropertiesState, RootState>,
  offset?: number) {
  if (context.state.items.length > 0) return
  try {
    const propertiesCollection = await firebase.firestore().collection('properties')
    const properties = await propertiesCollection.get()
    let propList: Property[] = []
    for (let index = 0; index < properties.docs.length; index++) {
      const doc = properties.docs[index];
      //@ts-ignore
      propList.push(doc.data())
      propList[index].id = doc.id
    }
    context.state.items = propList
  } catch (error) {
    throw new Error(error);
  }
}

async function loadProperty(
  context: BareActionContext<PropertiesState, RootState>,
  propertyID: string,
) {
  try {
    const propertyReference = await firebase.firestore().collection('properties').doc(propertyID)
    const doc = await propertyReference.get()
    const data = doc.data()
    return data
  } catch (error) {
    throw new Error(error);
  }
}
